import { action } from "satcheljs";
import type EmailAddressWrapper from "owa-service/lib/contract/EmailAddressWrapper";
import type { ActionSource } from "owa-mail-store";
import type { MailboxInfo } from "owa-client-types";
import type AttachmentFileAttributes from "owa-attachment-file-types/lib/types/AttachmentFileAttributes";
import type BodyType from "owa-service/lib/contract/BodyType";

// This is a new version of the newMessage action built using SatchelV3. Ideally, newMessage action (and other mail compose actions) would be
// refactored to use SatchelV3, but that would be a huge change and is planned for the future (planned for Q12019). For now, the plan is to use the v3 version of
// newMessage action to trigger a newMessageV3 orchestrator that then calls the legacy newMessage
// The reason to do this is to improve the depdency graph so that consumers of newMessage don't need to take a dependecy on owa-mail-compose-actions
export interface NEW_MESSAGE_V3ActionMessage {
    actionSource: ActionSource;
    groupId: string | undefined;
    toEmailAddressWrappers: EmailAddressWrapper[] | undefined;
    ccEmailAddressWrappers: EmailAddressWrapper[] | undefined;
    bccEmailAddressWrappers: EmailAddressWrapper[] | undefined;
    subject: string | undefined;
    body: string | undefined;
    bodyType: BodyType | undefined;
    mailboxInfo: MailboxInfo | undefined;
    isPopout: boolean | undefined;
    attachmentFiles: AttachmentFileAttributes[] | undefined;
    shouldResolveRecipients: boolean | undefined;
    customLogData: Record<string, any> | undefined;
    owaType: string;
}

export const newMessageV3: (actionSource: ActionSource, groupId?: string, toEmailAddressWrappers?: EmailAddressWrapper[], ccEmailAddressWrappers?: EmailAddressWrapper[], bccEmailAddressWrappers?: EmailAddressWrapper[], subject?: string, body?: string, bodyType?: BodyType, mailboxInfo?: MailboxInfo, isPopout?: boolean, attachmentFiles?: AttachmentFileAttributes[], shouldResolveRecipients?: boolean, customLogData?: Record<string, any>) => NEW_MESSAGE_V3ActionMessage = action("NEW_MESSAGE_V3", (actionSource: ActionSource, groupId?: string, toEmailAddressWrappers?: EmailAddressWrapper[], ccEmailAddressWrappers?: EmailAddressWrapper[], bccEmailAddressWrappers?: EmailAddressWrapper[], subject?: string, body?: string, bodyType?: BodyType, mailboxInfo?: MailboxInfo, isPopout?: boolean, attachmentFiles?: AttachmentFileAttributes[], shouldResolveRecipients?: boolean, customLogData?: Record<string, any>): NEW_MESSAGE_V3ActionMessage => ({
    actionSource,
    groupId,
    toEmailAddressWrappers,
    ccEmailAddressWrappers,
    bccEmailAddressWrappers,
    subject,
    body,
    bodyType,
    mailboxInfo,
    isPopout,
    attachmentFiles,
    shouldResolveRecipients,
    customLogData,
    owaType: "newMessageV3",
}));

export interface ON_CLOSE_COMPOSEActionMessage {
    closeReason: string | undefined;
}
export const onCloseCompose: (closeReason: string | undefined) => ON_CLOSE_COMPOSEActionMessage = action("ON_CLOSE_COMPOSE", (closeReason: string | undefined): ON_CLOSE_COMPOSEActionMessage => ({
    closeReason,
}));
